import { useTranslation } from 'react-i18next'
import { Icon } from '../Icon/Icon'
import { cx } from '../utils/cx'
import './SavedCardSummary.css'

export interface SavedCardSummaryProps {
  /** "Visa"; sin marca se dice "Tarjeta" (el PMS no la devuelve) */
  brand?: string | null
  last4?: string | null
  /** "09/29" */
  expiry?: string | null
  holder?: string | null
  className?: string
}

/** Cabecera de tarjeta guardada (bundle B3 §3g): marca y últimas cifras, caducidad y titular. */
export function SavedCardSummary({ brand, last4, expiry, holder, className }: SavedCardSummaryProps) {
  const { t } = useTranslation()
  const name = brand ?? t('v2.ds.savedCard.tarjeta')
  const detail = [expiry ? t('v2.ds.savedCard.caduca', { expiry }) : null, holder].filter(Boolean).join(' · ')
  return (
    <div className={cx('hp-savedcard', className)}>
      <span className="hp-savedcard__brand" aria-hidden="true">
        {brand ? brand.slice(0, 4).toUpperCase() : <Icon name="credit-card" size={18} />}
      </span>
      <div className="hp-savedcard__text">
        <div className="hp-savedcard__title tnum">{last4 ? t('v2.ds.savedCard.acabada', { brand: name, last4 }) : name}</div>
        {detail && <div className="hp-savedcard__detail tnum">{detail}</div>}
      </div>
    </div>
  )
}
